import { render, staticRenderFns } from "./OpenAccountApply.vue?vue&type=template&id=4e8e8026&scoped=true"
import script from "./OpenAccountApply.vue?vue&type=script&lang=js"
export * from "./OpenAccountApply.vue?vue&type=script&lang=js"
import style0 from "./OpenAccountApply.vue?vue&type=style&index=0&id=4e8e8026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8e8026",
  null
  
)

export default component.exports